import UsernameList from './UsernameList';
export default function Dashboard() { return <UsernameList />; }
